var fields = {

  //Fields
  async patch(field) {
    var d = Object.assign({}, field)
    console.log("dao:savefield:")
    const db = window.firebase.firestore();
    var ref = db.collection("databases/" + window.eid + "/fields")
    var e = await ref.doc(d.id).set(d)
        .then((docRef) => {
            console.log("Document successfully updated!" + JSON.stringify(docRef));
            return docRef;
        })
        .catch((error) => {
            console.error("Error writing document: ", error);
        });
    return e;

},

  async post(field ) {
    console.log("dao:post:")
    const db = window.firebase.firestore();
    var ref = db.collection("databases/" + window.eid + "/fields")
    var e = await ref.doc(field.id).set(field)
      .then((docRef) => {
        console.log("Document successfully updated!" + JSON.stringify(docRef));
        return docRef;
      })
      .catch((error) => {
        console.error("Error writing document: ", error);
      });
    return e;

  },
  async upsert(  field) {
    var d = Object.assign({}, field)
    console.log("upsert")
    //If there'is a deviceId, save , otherwise, add
    if (field.id ) {
      var a = await this.patch(field);
      return field;
    }
    console.log(JSON.stringify(d))
    const db = window.firebase.firestore();
    var ref = db.collection("databases/" + window.eid + "/fields")
    var e = await ref.add(d)
      .then((docRef) => {
        console.log("Document successfully created!");
        return docRef;
      })
      .catch((error) => {
        console.error("Error writing document: ", error);
      });
    d.id = e.id;
    var a = await this.patch(d );
    return d;
    },

    async getAll( ) {
      console.log("will get fields")
      const db = window.firebase.firestore();
      let objects = [];
      var  ref = db.collection("databases/" + window.eid + "/fields") ;
      var ans = await ref
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            objects.push(
              doc.data()
            );
            console.log(doc.id, " => ", doc.data());
          });
          for (var a = 0; a < objects.length; a++)
            console.log("will return")
          return objects
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
          return error;
        });
      return ans;
    },
        
    async delete( fieldId) {
      const db = window.firebase.firestore();
      console.log("will delete :" + fieldId);
      let objects = [];
      var ans = db.collection("databases/" + window.eid + "/fields").doc( fieldId)
        .delete()
        .then(() => {
    
            console.log("field deleted")
          return "ok"
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
          return error;
        });
      return ans;
    },
    
}

export default fields;
